import isSSR from '@/utils/isSSR';
import logger from '@/app/logger';
import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { onServerPrefetch, type Ref } from 'vue';
import { newsItemQuery_Client } from './news.client';

export const opNewsQueryKey = 'opNews';

export default function useNewsNew(pageName: Ref<string>) {
  const queryFn = async () => {
    if (isSSR) {
      const { newsItemQuery_Server } = await import('../../server/data/news.server');
      return newsItemQuery_Server(pageName.value);
    } else {
      return newsItemQuery_Client(pageName.value);
    }
  };

  logger.info('useNewsNew', { pageName: pageName.value || '' });
  const query = useQuery({
    queryKey: [opNewsQueryKey, pageName],
    queryFn,
  });

  onServerPrefetch(async () => {
    const queryClient = useQueryClient();
    await queryClient.prefetchQuery({ queryKey: [opNewsQueryKey, pageName] });
  });

  return query;
}
